const Colors = {
  primary: '#212529',
  text: {
    white: '#F8F9FA',
    dark: '#343A40'
  },
  background: {
    dark: '#212529',
    white: '#F8F9FA'
  },
  input: {
    background: '#E9ECEF',
    placeholder: '#6C757D'
  },
  error: '#FF6A6A',
  success: '#198754'
}

export default Colors
